import { ParserDocument } from "@/shared/repository/modules/parser/enums";

// The supplied AEX references contain no client agreement templates.
// Keep MEX legal documents out of the separate AEX bundle entirely.
export const ParserDocuments = Object.fromEntries(
  Object.values(ParserDocument).map((name) => [name, ""])
) as Record<ParserDocument, string>;

export const ParserField = Object.fromEntries(
  Object.values(ParserDocument).map((name): [ParserDocument, string[]] => [
    name,
    [],
  ])
) as Record<ParserDocument, string[]>;
